import { getLanguageValue } from "../../utils";
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/id'

const subAdapter = {
  date_time: {
    formToRequestBody(date, time){
      // tell dayjs how to parse the input string
      var dayjsObj = dayjs(date + time, 'YYYY-MM-DDLT');

      return dayjsObj.format('YYYY-MM-DDTHH:mm:s');
    },
    responseBodyToRender(date, locale){
      let result

      if(locale){
        result = dayjs(date).locale(locale).format(locale === 'id' ? 'LLLL' : 'llll');
      } else {
        result = dayjs(date).format('llll');
      }

      return result
    }
  }
}

const adapter = {
  ...subAdapter,
  responseBodyArrayToBilingualObject(input = []){
    const output = {
      en: '',
      id: ''
    }

    if(input && input.length > 0){
      let isError = false
      for (let index = 0; index < input.length; index++) {
        const element = input[index];

        if(element.nama){
          output.en += getLanguageValue(element.nama, 'en')
          output.id += getLanguageValue(element.nama, 'id')
        } else {
          isError = true
        }

        if(index < input.length-1){
          output.en += ', '
          output.id += ', '
        }
      }
      if(isError){
        console.error(`Error 500: One of the elements doesn't have field 'nama'`)
      }
    }

    return output
  }
}

export default adapter

